<template>
  <div class="wg-row">
    <div class="wg-row" style="font-size: 22px">
      <slot name="title"></slot>
    </div>
    <div class="vertical-height-div" style="height: 20px"></div>
    <!-- Form -->
    <div class="wg-row" style="flex-direction: row-reverse">
      <div v-if="hinting" class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row" style="flex-direction: column">
          <div class="wg-row" style="justify-content: center">
            <div class="com-anm22-app-text-xxl">
              {{
                $anm22.strLang(lang, "Contacts hints", "Suggerimento contatti")
              }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <!-- Suggerimenti dati di fatturazione -->
          <div class="wg-row">
            <div
              v-if="hintsLoading"
              class="wg-row"
              style="margin: 10px; justify-content: center"
            >
              <vue-simple-spinner size="medium" :line-fg-color="appColor" />
            </div>
            <div
              v-for="(hint, i) in billingHints"
              :key="'hint-' + i"
              class="billing-data-hint-item"
              @click="setDataFromHint(hint)"
            >
              <div class="name">
                {{ hint.name }}
              </div>
              <div v-if="hint.vatNumber" class="taxcode">
                {{ hint.vatNumber }}
              </div>
              <div v-if="hint.taxCode" class="taxcode">
                {{ hint.taxCode }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="['wg-col', 'wg-xs-12', hinting ? 'wg-sm-6' : '']">
        <div class="wg-row" style="flex-direction: column">
          <div class="wg-row" style="justify-content: center">
            <div class="com-anm22-app-text-xxl">
              {{ $anm22.strLang(lang, "Customer data", "Dati cliente") }}
            </div>
          </div>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Name", "Nome") }}
          </div>
          <template v-if="errors.includes('name')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "No name provided",
                  "Inserire denominazione"
                )
              }}
            </div>
          </template>
          <input
            type="text"
            autocomplete="off"
            v-model="customerData.name"
            :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
            :style="{ border: errors.includes('name') ? '1px solid red' : '' }"
            @keyup="searchBillingData"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "VAT", "P. IVA") }}
          </div>
          <template v-if="errors.includes('vatNumber')">
            <template v-if="errors.includes('taxCode')">
              <div class="wg-row com-anm22-app-text-l" style="color: red">
                {{
                  $anm22.strLang(
                    lang,
                    "No VAT number/Tax code provided",
                    "Inserire P.IVA o Codice fiscale"
                  )
                }}
              </div>
            </template>
            <template v-else>
              <div class="wg-row com-anm22-app-text-l" style="color: red">
                {{
                  $anm22.strLang(
                    lang,
                    "VAT number not valid (11 digits)",
                    "Partita IVA non valida (11 cifre)"
                  )
                }}
              </div>
            </template>
          </template>
          <input
            type="text"
            v-model="customerData.vatNumber"
            :placeholder="$anm22.strLang(lang, 'VAT', 'P. IVA')"
            :style="{
              border: errors.includes('vatNumber') ? '1px solid red' : '',
            }"
            @keyup="searchBillingData"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Tax code", "Codice fiscale") }}
          </div>
          <input
            type="text"
            v-model="customerData.taxCode"
            :placeholder="$anm22.strLang(lang, 'Tax code', 'Codice fiscale')"
            :style="{
              border: errors.includes('taxCode') ? '1px solid red' : '',
            }"
            @keyup="searchBillingData"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Street", "Via") }}
          </div>
          <template v-if="errors.includes('street')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(lang, "No street name provided", "Inserire via")
              }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.street"
            :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
            :style="{
              border: errors.includes('street') ? '1px solid red' : '',
            }"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Number", "Numero") }}
          </div>
          <template v-if="errors.includes('number')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "No street number provided",
                  "Inserire numero civico"
                )
              }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.number"
            :style="{
              border: errors.includes('number') ? '1px solid red' : '',
            }"
            :placeholder="$anm22.strLang(lang, 'Number', 'Numero')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "City", "Città") }}
          </div>
          <template v-if="errors.includes('city')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{ $anm22.strLang(lang, "No city provided", "Inserire città") }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.city"
            :style="{ border: errors.includes('city') ? '1px solid red' : '' }"
            :placeholder="$anm22.strLang(lang, 'City', 'Città')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "ZIP code", "CAP") }}
          </div>
          <template v-if="errors.includes('zip')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "Zip code not valid",
                  "CAP non inserito o invalido"
                )
              }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.zip"
            :style="{ border: errors.includes('zip') ? '1px solid red' : '' }"
            :placeholder="$anm22.strLang(lang, 'ZIP code', 'CAP')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "State", "Provincia") }}
          </div>
          <template v-if="errors.includes('state')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "State not valid",
                  "Provincia non inserita o invalida (sigla)"
                )
              }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.state"
            :style="{ border: errors.includes('state') ? '1px solid red' : '' }"
            :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Country", "Nazione") }}
          </div>
          <template v-if="errors.includes('country')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "Country not valid",
                  "Nazione non inserita o invalida"
                )
              }}
            </div>
          </template>
          <select
            class="com-anm22-app-select"
            :style="{
              border: errors.includes('country') ? '1px solid #red' : '',
            }"
            v-model="customerData.country"
          >
            <option
              v-for="(
                country, key, index
              ) in $anm22.tableClasses.worldCountry().getAll()"
              :key="'country-' + index"
              :value="key"
            >
              {{ country[lang] }}
            </option>
          </select>
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "PEC", "PEC") }}
          </div>
          <template v-if="errors.includes('pec') && errors.includes('sdi')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "SDI or PEC must be provided",
                  "Inserire PEC o SDI"
                )
              }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.pec"
            :placeholder="$anm22.strLang(lang, 'PEC', 'PEC')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "SDI", "SDI") }}
          </div>
          <template v-if="errors.includes('sdi')">
            <div class="wg-row com-anm22-app-text-l" style="color: red">
              {{
                $anm22.strLang(
                  lang,
                  "SDI not provided or invalid",
                  "SDI non inserito o invalido"
                )
              }}
            </div>
          </template>
          <input
            type="text"
            v-model="customerData.sdi"
            :style="{ border: errors.includes('sdi') ? '1px solid red' : '' }"
            :placeholder="$anm22.strLang(lang, 'SDI', 'SDI')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "Notes", "Note addizionali") }}
          </div>
          <input
            type="text"
            v-model="customerData.notes"
            :placeholder="$anm22.strLang(lang, 'Notes', 'Note addizionali')"
          />
          <div class="vertical-height-div" style="height: 10px"></div>
          <!-- Custom additional content -->
          <!-- <div class="wg-row">
            <slot name="custom-data"></slot>
          </div> -->
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <div class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Create', 'Crea')"
        @click="create"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import Spinner from "vue-simple-spinner";

export default {
  components: {
    "vue-simple-spinner": Spinner,
  },
  props: {
    hinting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: [],
      customerData: {
        name: "",
        taxCode: "",
        vatNumber: "",
        street: "",
        number: "",
        city: "",
        state: "",
        zip: "",
        country: "it",
        pec: "",
        sid: "",
        notes: "",
      },
      billingHints: [],
      hintsLoading: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      licenseSelected: (state) => state.licenseSelected,
      appColor: (state) => state.config.appColor,
    }),
  },
  methods: {
    searchBillingData: _.debounce(async function (event) {
      if (this.hinting) {
        this.hintsLoading = true;
        this.billingHints = [];
        const response = await this.$http.get("invoice/hints", {
          params: {
            q: this.customerData.name,
            v: this.customerData.vatNumber,
            t: this.customerData.taxCode,
          },
        });
        if (response.data) {
          this.hintsLoading = false;
          this.billingHints = response.data.hints;
        }
      }
    }, 1000),
    setDataFromHint(hint) {
      Object.assign(this.customerData, hint);
      this.billingHints = [];
    },
    create() {
      this.errors = [];
      // Verifica campi
      if (!this.customerData.name) {
        this.errors.push("name");
      }
      if (!this.customerData.vatNumber && !this.customerData.taxCode) {
        this.errors.push("vatNumber", "taxCode");
      }
      if (
        this.customerData.country === "it" &&
        this.customerData.vatNumber &&
        (this.customerData.vatNumber.length !== 11 ||
          !this.onlyDigits(this.customerData.vatNumber))
      ) {
        this.errors.push("vatNumber");
      }
      if (!this.customerData.street) {
        this.errors.push("street");
      }
      if (!this.customerData.number) {
        this.errors.push("number");
      }
      if (!this.customerData.city) {
        this.errors.push("city");
      }
      if (
        !this.customerData.zip ||
        (this.customerData.country === "it" &&
          (this.customerData.zip.length !== 5 ||
            !this.onlyDigits(this.customerData.zip)))
      ) {
        this.errors.push("zip");
      }
      if (
        !this.customerData.state ||
        (this.customerData.country === "it" &&
          (this.customerData.state.length !== 2 ||
            !this.onlyChars(this.customerData.state)))
      ) {
        this.errors.push("state");
      }
      if (!this.customerData.country) {
        this.errors.push("country");
      }
      if (this.customerData.country === "it" && this.customerData.vatNumber) {
        if (!this.customerData.sdi && !this.customerData.pec) {
          this.errors.push("sdi", "pec");
        } else {
          if (
            this.customerData.sdi !== "" &&
            (this.customerData.sdi.length !== 7 ||
              !this.alphanumeric(this.customerData.sdi))
          ) {
            this.errors.push("sdi");
          }
        }
      }
      if (this.errors.length > 0) {
        return;
      } else {
        if (this.customerData.country === "it" && this.customerData.vatNumber) {
          this.customerData.sdi = this.customerData.sdi.toUpperCase();
          this.customerData.state = this.customerData.state.toUpperCase();
        }
        this.$emit("create-invoice", this.customerData);
      }
    },
    // utils
    onlyDigits(value) {
      return /^\d+$/.test(value);
    },
    onlyChars(value) {
      return /^[a-zA-Z]+$/.test(value);
    },
    alphanumeric(value) {
      return /^[a-zA-Z0-9]+$/.test(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.billing-data-hint-item {
  display: block;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  margin: 10px;
  max-width: 300px;
}
.billing-data-hint-item .name {
  font-size: 16px;
  color: #222;
}
.billing-data-hint-item .taxcode {
  font-size: 14px;
  color: #777;
  margin-top: 5px;
}
</style>